import {
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAILURE,
  UPDATE_PROJECT_REQUEST,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  RESET_PROJECT_STATE,
  GET_CURRENT_PROJECT,
  PROJECT_LOADER_START,
  PROJECT_LOADER_STOP,
} from "./types";

const initialState = {
  loading: false,
  error: null,
  currentProject: null,
  projectDetails: null,
  success: false,
};

const data360LiveProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_LOADER_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PROJECT_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };

    // Project Creation - SET LOADING TO TRUE
    case CREATE_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentProject: action.payload || [],
        error: null,
        success: true,
      };
    case CREATE_PROJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    // Get Project Details - SET LOADING TO TRUE
    case GET_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        projectDetails: action.payload || [],
        error: null,
      };
    case GET_PROJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Project - SET LOADING TO TRUE
    case UPDATE_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentProject: state.currentProject,
        error: null,
        success: true,
      };
    case UPDATE_PROJECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    // Get Current Project
    case GET_CURRENT_PROJECT:
      return {
        ...state,
        currentProject: action.payload || [],
      };

    // Reset State
    case RESET_PROJECT_STATE:
      return initialState;

    default:
      return state;
  }
};

export default data360LiveProjectReducer;
